import "../pagesCss/comingSoon.scss";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

function Solliciter() {
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!formdata.name) {
      setError(true);
      setMessage("Veuillez renseigner votre nom");
    } else if (!formdata.email) {
      setError(true);
      setMessage("Veuillez renseigner votre Email");
    } else if (!formdata.subject) {
      setError(true);
      setMessage("Veuillez renseigner un objet");
    } else if (!formdata.message) {
      setError(true);
      setMessage("Veuillez saisir votre Message");
    } else {
      setError(false);
      setMessage("Votre message a été reçu!!!");
    }

    setLoading(true);
    try {
      let url = "http://localhost:1337/api/messages";
      const res = await axios.post(url, { data: formdata });
      console.log("data from message post", res.data.data);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setFormdata({
      ...formdata,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  const handleAlerts = () => {
    if (error && message) {
      return <div className="alert alert-danger mt-4">{message}</div>;
    } else if (!error && message) {
      return <div className="alert alert-success mt-4">{message}</div>;
    } else {
      return null;
    }
  };

  return (
    <>
      <div className="container">
        <h1>Sollicitez le service qui vous tient a coeur 👨‍💻</h1>
        <p style={{flex:1, alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'flex-start'}}>
        🎉🎁👏🌟 Vous avez un projet qui vous tient à cœur? Vous cherchez un service qui répondra à vos besoins spécifiques? Ne cherchez plus! Notre entreprise est là pour vous aider à réaliser votre rêve! 🤝💪🌟

Nous offrons une gamme complète de services personnalisés pour répondre à tous vos besoins, que vous cherchiez à développer votre entreprise ou à réaliser un projet personnel. 🚀🏡🌟

Notre équipe dévouée et expérimentée est là pour vous aider à chaque étape du processus, en vous offrant des conseils, des ressources et des compétences pour vous aider à atteindre votre objectif. 💼📈💻

Chez nous, votre satisfaction est notre priorité numéro un. Nous nous engageons à travailler avec vous pour créer un service qui répondra à vos attentes et vous donnera le meilleur résultat possible. 🤝👍💯

Ne laissez pas vos projets prendre la poussière. Contactez-nous aujourd'hui et sollicitez notre service pour réaliser votre rêve! 🌟🚀👏
        </p>
        {/* <form className="join-wrapper">
          <input type="email" id="email" placeholder="Saisir votre email" />
          <button data-toggle="modal" data-target="#loginModal">
            Yes 💪
          </button>
        </form> */}
        <form
          id="contact-form"
          className="contact-form mt-6"
          onSubmit={submitHandler}
        >
          <div className="row">
            <div className="column col-md-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  id="InputName"
                  placeholder="Votre nom"
                  onChange={handleChange}
                  value={formdata.name}
                />
              </div>
            </div>

            <div className="column col-md-4">
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  id="InputEmail"
                  name="email"
                  placeholder="Adresse email"
                  onChange={handleChange}
                  value={formdata.email}
                />
              </div>
            </div>

            <div className="column col-md-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="InputSubject"
                  name="subject"
                  placeholder="Objet"
                  onChange={handleChange}
                  value={formdata.subject}
                />
              </div>
            </div>
            <div className="row">
              <div className="column col-md-9">
                <div className="form-group">
                  <textarea
                    name="message"
                    id="InputMessage"
                    className="form-control"
                    placeholder="Message"
                    onChange={handleChange}
                    value={formdata.message}
                  ></textarea>
                </div>
              </div>
              <div className="column col-md-12" hidden={true}>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="InputSubject"
                      name="service"
                      defaultValue="Solliciter"
                      value={formdata.service}
                    />
                  </div>
                </div>
              <div className="column col-md-2">
                <div
                  className="form-group"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <button
                    type="submit"
                    name="submit"
                    id="submit"
                    value="Submit"
                    className="btn btn-default"
                  >
                    Solliciter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        {handleAlerts()}
      </div>
    </>
  );
}

export default Solliciter;
